import React, { useState } from "react";
import InsuranceDropdown from "../InsuranceDropdownComponent/InsuranceDropdown";

export default function InsuranceAddModal({ onClose, onSave }) {
  const [form, setForm] = useState({
    planName: "",
    planType: "",
    availablePlanTypes: [], // from selected plan
  });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  const handlePlanChange = (selectedPlan) => {
    setForm((s) => ({
      ...s,
      planName: selectedPlan?.planName || "",
      planType: "", // reset
      availablePlanTypes: selectedPlan?.planTypes || [],
    }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setSaving(true);
    try {
      if (!form.planName || !form.planType) {
        throw new Error("Please select both plan and plan type.");
      }
      await onSave({ planName: form.planName, planType: form.planType });
    } catch (ex) {
      setErr(ex?.message || "Failed to add insurance");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative z-10 w-full max-w-xl rounded-xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">Add Insurance</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <label className="block">
              <span className="text-sm text-gray-700">Insurance Plan</span>
              <InsuranceDropdown
                value={form.planName}
                onChange={handlePlanChange}
              />
            </label>

            <label className="block">
              <span className="text-sm text-gray-700">Plan Type</span>
              <select
                className="mt-1 w-full rounded-md border px-3 py-2"
                value={form.planType}
                onChange={(e) =>
                  setForm((s) => ({ ...s, planType: e.target.value }))
                }
                required
              >
                <option value="">Select Plan Type</option>
                {(form.availablePlanTypes || []).map((t) => (
                  <option key={t.id} value={t.typeName}>
                    {t.typeName}
                  </option>
                ))}
              </select>
            </label>
          </div>

          {err && <p className="text-sm text-red-600">{err}</p>}

          <div className="mt-4 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded border px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="rounded bg-emerald-600 px-4 py-2 text-sm text-white hover:bg-emerald-700 disabled:opacity-60"
            >
              {saving ? "Saving…" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
